import axios from 'axios';
import UserProfile from "components/UserProfile/UserProfile";
import { apiUrl } from 'config';
import toast from "react-hot-toast";
import API from './API';

export const fetchWarehouseData = async (display, warehouse, filters = {}, sort = {}) => {
    const url = "" + "admin/get_warehouse_data";
    let formData = new FormData();
    formData.append("warehouse", warehouse);
    formData.append("display", display);
    formData.append("filters", JSON.stringify(filters));
    formData.append("sort", JSON.stringify(sort));
    const data = await API.postData(url, formData);
    return data;
};

export const printLabels = async (orders) => {
    let formData = new FormData();
    formData.append("orders", JSON.stringify(orders));

    try {
        const token = await UserProfile.getToken();
        const response = await axios.post(
            `${apiUrl}admin/print_labels`, // API endpoint
            formData, // Request body (null if no body is needed)
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: null, // Query parameters
            }
        );
        toast.success(response.data.msg);
        return response;
    }
    catch (error) {
        error.response.data?.msg ? toast.error(error.response.data.msg) : toast.error(error.response.data)
    }
};

export const getOrderPartials = async (filters = {}) => {
    const token = await UserProfile.getToken();
    try {
        const response = await axios.get(`${apiUrl}admin/order/partials`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: filters
        });
        toast.success(response.data.message);
    }
    catch (error) {
        error.response.data?.message ? toast.error(error.response.data.message) : toast.error(error.response.data)
    }
    return response
};

export const confirmQRCode = async (orderId, QRCode) => {
    const token = await UserProfile.getToken();
    let formData = new FormData();
    formData.append("orderId", orderId);
    formData.append("qrOrderId", QRCode);

    const response = await axios.post(
        `${apiUrl}admin/scan_qr_code`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response;
};

export const fetchWarehouseStatus = async (warehouse) => {
    const token = await UserProfile.getToken();
    const response = await axios.get(`${apiUrl}admin/get_warehouse_status`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: { warehouse }
    });
    return response.data;
}

export const fetchWarehouseDashboardData = async (timeRange, warehouse) => {
    const token = await UserProfile.getToken();    
    let formData = new FormData();
    formData.append("warehouse", warehouse);
    formData.append("timeRange", timeRange);
    // const url = "" + "admin/get_warehouse_dashboard_data";
    // const data = await API.postData(url, formData);

    const response = await axios.post(
        `${apiUrl}admin/get_warehouse_dashboard_data`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response.data;
  };